// extracted by mini-css-extract-plugin
module.exports = {"icon":"NextButton_icon__1znrq","wrapper":"NextButton_wrapper__3uI6R"};